import type { FormTranslations } from "../../types/forms";

export const forms: FormTranslations = {
  validation: {
    required: "This field is required",
    minLength: "Must be at least {min} characters",
    maxLength: "Must be no more than {max} characters",
    pattern: "Invalid format",
    email: "Must be a valid email address",
    number: "Must be a valid number",
    date: "Must be a valid date",
    invalidYear: "Please enter a valid year (YYYY)",
    emailRequired: "Email is required",
    fieldsRequired: "Please check all required fields are filled correctly.",
    invalidName: "Invalid name",
    orgNameMinLength: "Organisation name must be at least 2 characters",
    error: "Validation Error",
  },
  buttons: {
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
  },
  status: {
    saving: "Processing...",
    saved: "Saved successfully",
    error: "Error saving data",
  },
  login: {
    title: "Log In",
    description: "Enter your credentials to access your account",
    heading: "Sign in and ask Franklin",
    taglines: [
      "Ask the building. It was there the whole time.",
      "Knowledge is created by connection.",
      "You can't track what you can't compare.",
      "Knowing beats guessing. Every time.",
      "First you organise. Then you know.",
      "Change is constant. Losing track of it is optional.",
      "Somewhere in folder 47, the answer exists.",
      "The best version of a drawing is the one you can actually find.",
      "Nobody ever said: “I wish this project had more folders.”",
      "“Final_v3_REAL_final.dwg” is not a version control system.",
    ],
    newHere: "New here?",
    bookDemo: "Book a demo",
    emailLabel: "Email",
    passwordLabel: "Password",
    forgotPassword: "Forgot password?",
    submitButton: "Log In",
    noAccountYet: "Don't have an account yet?",
    signUpLink: "Sign up",
    emailPlaceholder: "you@company.com",
    passwordPlaceholder: "Enter your password",
    privacyText: "By signing up, you agree to our Terms and Privacy Policy",
    selectOrganization: "Select Organisation",
    noOrganizations: "No organisations available",
    organizationRequired: "Please select an organisation",
    verifyEmailNotice: "Please verify your email address before logging in.",
  },
  signup: {
    title: "Create an Account",
    description: "Sign up to get started",
    firstNameLabel: "First Name",
    lastNameLabel: "Last Name",
    organizationLabel: "Organisation",
    organizationPlaceholder: "Enter your organisation name",
    organizationRequired: "Organisation name is required",
    terms: "I agree to the Terms and Conditions",
    termsRequired: "You must agree to the terms",
    submitButton: "Sign Up",
  },
  passwordReset: {
    title: "Reset Password",
    checkEmailTitle: "Check Your Email",
    description: "Enter your email to receive password reset instructions",
    checkEmailDescription:
      "If an account exists with this email, you will receive password reset instructions.",
    newPasswordLabel: "New Password",
    confirmPasswordLabel: "Confirm Password",
    sendInstructionsButton: "Send Reset Instructions",
    resetPasswordButton: "Reset Password",
    backToLogin: "Back to Login",
    resetSuccess: "Password has been reset successfully",
    passwordMismatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 8 characters long",
    enterCodeTitle: "Enter Verification Code",
    enterCodeDescription: "Enter the 6-digit code sent to your email",
    verificationCode: "Verification Code",
    verifyCodeButton: "Verify Code",
    sendCodeButton: "Send Verification Code",
    codeExpires: "Code expires in",
    seconds: "seconds",
    resendCode: "Resend Code",
    codeVerified: "Code verified successfully",
    newPasswordTitle: "Set New Password",
    newPasswordDescription: "Enter your new password",
    invalidCode: "Please enter a valid 6-digit code",
    incorrectCode: "Incorrect verification code",
    codeExpired: "Verification code expired",
    noCodeFound: "No verification code found",
    checkEmailForCode: "Please check your email for the verification code",
    verifying: "Verifying your reset link...",
    invalidToken: "Invalid or expired password reset link. Please request a new one.",
    requestNewResetLinkButton: "Request New Reset Link",
  },
  passwordStrength: {
    veryWeak: "Very weak",
    weak: "Weak",
    fair: "Fair",
    good: "Good",
    strong: "Strong",
    invalid: "Invalid",
  },
  error: {
    allFieldsRequired: "All fields are required",
    invalidCredentials: "Invalid email or password",
    unexpectedError: "An unexpected error occurred",
    tooManyAttempts: "Too many login attempts. Please try again later.",
    invalidEmail: "Please enter a valid email address",
  },
  success: {
    loginSuccessful: "Login successful",
    signupSuccessful: "Successfully signed up!",
    checkEmail: "Please check your email to continue",
    passwordResetSent: "Password reset instructions sent to your email",
    passwordResetSuccess: "Password has been reset successfully",
  },
  showPassword: "Show password",
  hidePassword: "Hide password",
  constructionType: "Construction Type",
  floors: "Number of Floors",
  parkingSpaces: "Parking Spaces",
  energyRating: "Energy Rating",
  lastRenovationDate: "Last Renovation Date",
  createOrganization: {
    title: "Create Your Organisation",
    description: "Set up your organisation to start managing buildings",
    name: "Organisation Name",
    placeholder: "e.g., Franklin Corporation",
    submit: "Create Organisation",
    signedInAs: "Signed in as {email}",
    signOut: "Sign out",
  },
};
